import { render, staticRenderFns } from "./StaffTurnover.vue?vue&type=template&id=2077e1bd&scoped=true"
import script from "./StaffTurnover.vue?vue&type=script&lang=ts"
export * from "./StaffTurnover.vue?vue&type=script&lang=ts"
import style0 from "./StaffTurnover.vue?vue&type=style&index=0&id=2077e1bd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2077e1bd",
  null
  
)

export default component.exports